import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const Checkmark = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Checkmark({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M20.6464 6.76551C20.8417 6.96077 20.8417 7.27735 20.6464 7.47261L10.2949 17.8242C9.77987 18.3392 8.94484 18.3392 8.4298 17.8242L3.35355 12.7479C3.15829 12.5526 3.15829 12.2361 3.35355 12.0408L3.76551 11.6288C3.96077 11.4336 4.27735 11.4336 4.47261 11.6288L9.36235 16.5186L19.5274 6.35355C19.7226 6.15829 20.0392 6.15829 20.2345 6.35355L20.6464 6.76551Z'
      fill={color}
    />
  ));
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'checkmark-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Checkmark;
